<template>
  <div>
    <zj-layout-container class="user-layout">
      <div class="zj-layout-left">
        <div class="zj-left-main">
          <el-tree
            style="{ width }"
            :data="Orgs"
            :props="defaultProps"
            @node-click="handleNodeClick"
            highlight-current="true"
          ></el-tree>
        </div>
      </div>
      <div class="zj-layout-right">
        <zj-layout-header>
          <el-form
            class="zj-search-form"
            ref="form"
            :model="form"
            :label-width="labelWidth"
          >
            <el-form-item label="用户名">
              <el-input
                v-model="User_Name"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="登录名">
              <el-input
                v-model="Login_Name"
                placeholder="请输入登录名"
              ></el-input>
            </el-form-item>
            <el-form-item label class="right">
              <el-button @click="onSearch">查 询</el-button>
              <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
        </zj-layout-header>
        <zj-layout-main>
          <div class="zj-button-bar">
            <el-button size="mini" @click="onAdd">添 加</el-button>
            <el-button size="mini" @click="onbatchDel">删 除</el-button>
          </div>
          <div class="zj-layout-main-content bgcolor scrollable">
            <div class="zj-table-container">
              <el-table
                :data="tableData"
                ref="multipleTable"
                @selection-change="selectionChange"
                border
                style="width: 100%"
                fixed
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="UserName"
                  label="用户名"
                ></el-table-column>
                <el-table-column
                  prop="LoginName"
                  label="登录名"
                ></el-table-column>
                <el-table-column
                  prop="Sex"
                  label="性别"
                  :formatter="getSex"
                ></el-table-column>
                <el-table-column prop="Phone" label="手机号"></el-table-column>
                <el-table-column
                  prop="Birthday"
                  label="生日"
                  :formatter="formatTime"
                ></el-table-column>
                <el-table-column fixed="right" label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      @click="editClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                    <el-button
                      @click="RightsClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >角色分配</el-button
                    >
                    <el-button
                      v-if="IsAdministrator"
                      @click="ResetPasswd(scope.row)"
                      type="text"
                      size="small"
                      >重置密码</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </zj-layout-main>
        <zj-layout-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="total"
          ></el-pagination>
        </zj-layout-footer>
      </div>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <UserInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :SelectedOrgId="this.SelectedOrg.OrgId"
        :User_Id="this.SelectedUserId"
      ></UserInfoPage>
    </ZjDialog>
    <ZjDialog
      :title="Roledilaogconfig.title"
      :dialogFormVisible="Roledilaogconfig.dialogFormVisible"
      :width="Roledilaogconfig.width"
      :height="Roledilaogconfig.height"
      @clickCancel="RoleshandleDialogCancel"
    >
      <ChoseRolesPage
        @clickOk="RoleshandleDialogOk"
        @clickCancel="RoleshandleDialogCancel"
        :User_Id="this.SelectedUserId"
        :User_Name="this.SelectedUserName"
      ></ChoseRolesPage>
    </ZjDialog>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";
import UserInfoPage from "./userinfo.vue";
import ChoseRolesPage from "./choseroles.vue";

export default {
  name: "UserPage",
  controller: "UI",
  action: "users",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      Orgs: null,
      defaultProps: {
        children: "OrgInfos",
        label: "OrgName",
      },
      SelectedOrg: "",
      SelectedUserId: "",
      SelectedUserName: "",
      User_Name: "",
      Login_Name: "",
      tableHeight: window.innerHeight - 440,
      Org_Code: "Org-Longmenshiku",
      dilaogconfig: {
        title: "添加用户",
        dialogFormVisible: false,
        width: "900px",
      },
      Roledilaogconfig: {
        title: "分配角色",
        dialogFormVisible: false,
        width: "300px",
      },
      multipleSelection: [],
      IsAdministrator: false,
    };
  },
  components: {
    UserInfoPage,
    ChoseRolesPage,
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function() {
    this.init();
  },
  mounted: function() {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.tableHeight = window.innerHeight - 440;
      })();
    };
    this.GetUsers();
    this.logInfo.ActionName = "用户管理查看";
    this.logInfo.LogMessage = "用户管理查看";
    this.logInfo.ModuleName = "权限管理";
    this.logInfo.PageName = "用户管理列表页面";
    this.addOperationLog();
  },
  computed: {},
  methods: {
    // 初始化
    init() {
      return utils.waitAll(
        [this.GetUserIsAdministrator(), () => this.GetOrgsByUserId()],
        (r) => {
          this.IsAdministrator = r[0].data.Data;
          console.log(this.IsAdministrator);
        }
      );
    },
    GetUserIsAdministrator() {
      let user = this.user;
      var userId = user.UserId;
      let RoleInfoSearch = {
        UserId: userId,
      };

      return new WebApis.RoleApi().IsAdministrator(RoleInfoSearch);
    },
    GetOrgsByUserId() {
      let user = this.user;
      let userId = user.UserId;

      let TreeSearch = {
        UserId: userId,
      };
      console.log(TreeSearch);
      return new WebApis.TreeApi()
        .GetOrgTreeByUserId(TreeSearch)
        .then((res) => {
          console.log(res);
          this.Orgs = res.data.Data;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取组织机构失败!" + e.RspMsg
              : "获取组织机构失败!",
            type: "error",
          });
        });
    },
    GetUsers() {
      showLoading(".zj-table-container");

      let user = this.user;
      let userId = user.UserId;

      let OrgUserInfoSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        OrgId: this.SelectedOrg ? this.SelectedOrg.OrgId : "",
        UserId: userId,
        UserName: this.User_Name,
        LoginName: this.Login_Name,
      };

      new WebApis.OrgUserApi()
        .GetUsersPagingByOrgId(OrgUserInfoSearch)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取用户数据异常！" + e.RspMsg
              : "获取用户数据异常！",
            type: "error",
          });
          hideLoading();
        });
    },
    // 点击查询按钮
    onSearch() {
      this.GetUsers();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetUsers();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetUsers();
    },
    handleNodeClick(data) {
      this.SelectedOrg = data;
      this.GetUsers();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    getSex(row, column) {
      const sex = row[column.property];
      if (sex == 0) {
        return "女";
      } else {
        return "男";
      }
    },
    onCancel() {
      this.User_Name = "";
      this.Login_Name = "";
    },
    onAdd() {
      this.SelectedUserId = "";
      if (this.SelectedOrg) {
        this.dilaogconfig.dialogFormVisible = true;
      } else {
        this.$message({
          showClose: true,
          message: "请选择组织机构！",
          type: "error",
        });
      }
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    onbatchDel() {
      let User_Ids = [];
      this.multipleSelection.forEach((item) => {
        User_Ids.push(item.UserId);
      });

      if (User_Ids.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择要删除的数据!",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定删除选中用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let UserInfoSearch = {
          UserIds: User_Ids,
        };
        new WebApis.UserApi()
          .DelItemList(UserInfoSearch)
          .then((r) => {
            if (r.RspCode == "1") {
              this.$message({ type: "success", message: "删除成功!" });
              this.GetUsers();
            } else {
              this.$message({
                showClose: true,
                message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                type: "error",
              });
            }
            this.logInfo.ActionName = "用户删除";
            this.logInfo.LogMessage =
              r.RspCode == "1" ? "用户删除成功" : "用户删除失败";
            this.logInfo.ModuleName = "权限管理";
            this.logInfo.PageName = "用户管理列表页面";
            this.addOperationLog();
          })
          .catch((e) => {
            this.$message({
              showClose: true,
              message: e.RspMsg ? "删除失败!" + e.RspMsg : "获取用户信息失败!",
              type: "error",
            });
          });
      });
    },
    editClick(index, row) {
      this.SelectedUserId = row.UserId;
      this.SelectedUserName = row.UserName;
      this.dilaogconfig.title = "修改用户";
      this.dilaogconfig.dialogFormVisible = true;
    },
    deleteClick(index, row) {
      this.SelectedUserId = row.UserId;
      this.$confirm("确定删除该用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let UserInfo = {
          UserId: this.SelectedUserId,
        };
        new WebApis.UserApi()
          .DelItem(UserInfo)
          .then((r) => {
            if (r.RspCode == "1") {
              this.$message({ type: "success", message: "删除成功!" });
              this.GetUsers();
            } else {
              this.$message({
                showClose: true,
                message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                type: "error",
              });
            }
            this.logInfo.ActionName = "用户删除";
            this.logInfo.LogMessage =
              r.RspCode == "1" ? "用户删除成功" : "用户删除失败";
            this.logInfo.ModuleName = "权限管理";
            this.logInfo.PageName = "用户管理列表页面";
            this.addOperationLog();
          })
          .catch((e) => {
            this.$message({
              showClose: true,
              message: e.RspMsg ? "删除失败!" + e.RspMsg : "获取用户信息失败!",
              type: "error",
            });
          });
      });
    },
    RightsClick(index, row) {
      this.SelectedUserId = row.UserId;
      this.SelectedUserName = row.UserName;
      this.Roledilaogconfig.dialogFormVisible = true;
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetUsers();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
    RoleshandleDialogOk() {
      this.Roledilaogconfig.dialogFormVisible = false;
    },
    RoleshandleDialogCancel() {
      this.Roledilaogconfig.dialogFormVisible = false;
    },
    ResetPasswd(row) {
      new WebApis.UserApi()
        .ResetPassword({ LoginName: row.LoginName })
        .then((r) => {
          if (r) {
            this.$message({ type: "success", message: "密码重置成功!" });
            this.GetUsers();
          } else {
            this.$message({
              message: "密码重置失败!",
              type: "error",
            });
          }
          this.logInfo.ActionName = "用户密码重置";
          this.logInfo.LogMessage = r ? "用户密码重置成功" : "用户密码重置失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "用户管理列表页面";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
};
</script>
